import { motion } from "framer-motion";
import { Compass, Gem, Hammer } from "lucide-react";

const pillars = [
  {
    letter: "D",
    word: "Design",
    icon: Compass,
    text: "Un intérieur pensé pour vous : agréable à vivre au quotidien, accordé à vos goûts, et qui valorisera votre bien le jour où vous voudrez le revendre.",
  },
  {
    letter: "E",
    word: "Excellence",
    icon: Gem,
    text: "Des matériaux que nous choisirions pour notre propre maison. Des finitions qui tiennent dans le temps, sans micro-fissures ni retouches à prévoir.",
  },
  {
    letter: "M",
    word: "Maîtrise",
    icon: Hammer,
    text: "Un seul interlocuteur, du devis à la livraison. Pas de sous-traitants à gérer, pas de mauvaises surprises. Vous récupérez les clés à la date promise.",
  },
];

const ease = [0.16, 1, 0.3, 1];

export const Pillars = () => {
  return (
    <section
      id="pillars"
      data-testid="pillars-section"
      className="bg-cream py-24 sm:py-32 lg:py-40"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.8, ease }}
          className="max-w-3xl mb-16 lg:mb-24"
        >
          <span className="eyebrow">Notre nom, notre promesse</span>
          <h2 className="mt-4 font-serif text-charcoal text-4xl sm:text-5xl lg:text-6xl leading-[1.05] font-normal">
            Ce que <span className="italic text-bronze">DEM</span> signifie
            <br />
            pour nous.
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 lg:gap-16">
          {pillars.map((p, i) => {
            const Icon = p.icon;
            return (
              <motion.div
                key={p.letter}
                data-testid={`pillar-${p.letter.toLowerCase()}`}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-50px" }}
                transition={{ duration: 0.8, ease, delay: i * 0.15 }}
                className="group relative"
              >
                <div className="flex items-start gap-6 mb-8">
                  <span className="font-serif text-7xl lg:text-8xl text-bronze leading-none">
                    {p.letter}
                  </span>
                  <div className="pt-2">
                    <Icon className="w-7 h-7 text-charcoal-muted group-hover:text-bronze transition-colors duration-500" strokeWidth={1} />
                  </div>
                </div>
                <h3 className="font-serif text-2xl lg:text-3xl text-charcoal mb-4 font-normal">
                  {p.word}
                </h3>
                <p className="text-charcoal-muted text-base lg:text-lg leading-relaxed font-light">
                  {p.text}
                </p>
                <div className="mt-8 h-px w-12 bg-bronze/40 group-hover:w-24 group-hover:bg-bronze transition-all duration-700" />
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
